import { render, staticRenderFns } from "./ombudsman-event-modal.vue?vue&type=template&id=1b2ab42c&"
import script from "./ombudsman-event-modal.vue?vue&type=script&lang=js&"
export * from "./ombudsman-event-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports